export const primaryLocales = [
  {
    value: 'en',
    name: 'English',
  },
  {
    value: 'de',
    name: 'German',
  },
] as const;
export type PrimaryLocaleValues = (typeof primaryLocales)[number]['value'];

export function isPrimaryLocale(locale?: string): locale is PrimaryLocaleValues {
  return primaryLocales.some(({ value: maybeLocale }) => maybeLocale === locale);
}

export const supportedLocales = [
  ...primaryLocales,
  {
    value: 'en-US',
    name: 'English (US)',
  },
  {
    value: 'en-GB',
    name: 'English (UK)',
  },
  {
    value: 'en-AU',
    name: 'English (Australia)',
  },
  {
    value: 'en-CA',
    name: 'English (Canada)',
  },
  {
    value: 'en-IN',
    name: 'English (India)',
  },
  {
    value: 'en-IE',
    name: 'English (Ireland)',
  },
  {
    value: 'en-NZ',
    name: 'English (New Zealand)',
  },
  {
    value: 'en-ZA',
    name: 'English (South Africa)',
  },
  {
    value: 'de-DE',
    name: 'German (Germany)',
  },
  {
    value: 'de-AT',
    name: 'German (Austria)',
  },
  {
    value: 'de-LI',
    name: 'German (Liechtenstein)',
  },
  {
    value: 'de-CH',
    name: 'German (Switzerland)',
  },
] as const;
export type SupportedLocaleValues = (typeof supportedLocales)[number]['value'];
